import { concantQuery } from '@/utils/concatQuery'
import api from './api'
import EventEmitter from '@/utils/EventEmitter'
export const CarEventEmitter = new EventEmitter()

const wsEvents = {
  CAR_MANAGER_UPDATE_CAR: 'CAR_MANAGER_UPDATE_CAR',
  CAR_MANAGER_NEW_CAR: 'CAR_MANAGER_NEW_CAR',
}

/**
 * Listen websocket event
 * Example: wsListeners[wsEvents.SOME_EVENT](callback)
*/
const wsListeners = (() => {
  const listeners = Object.keys(wsEvents)
    .reduce((acc, eventName) => {
      acc[eventName] = (fn) => CarEventEmitter.on(eventName, fn)
      return acc
    }, {})

  return listeners
})()

const wrapAction = (action) => {
  if (!wsActions.socket) {
    CarEventEmitter.on('connect', action)
  } else {
    action()
  }
}

const wsActions = {
  socket: null,
  ACTION_JOIN_TO_CAR_MANAGER: () => {
    wrapAction(() => wsActions.socket.emit('ACTION_JOIN_TO_CAR_MANAGER'))
  },
  ACTION_TEST_MODE_CAR: ({ id, isTestMode }) => {
    
    wrapAction(() => wsActions.socket.emit('ACTION_TEST_MODE_CAR', { id, isTestMode }))
  },
  ACTION_SITE_CONFIG: ({ moduleName, status }) => {
    wrapAction(() => wsActions.socket.emit('ACTION_SITE_CONFIG', { moduleName, status }))
  },
  ACTION_VERIFY_CAR: ({ id, verificationState, declineReason }) => {
    wrapAction(() => wsActions.socket.emit('ACTION_VERIFY_CAR', { id, verificationState, declineReason }))
  },
  ACTION_CAR_FEATURED: ({ id, featured }) => {
    wrapAction(() => wsActions.socket.emit('ACTION_CAR_FEATURED', { id, featured }))
  },
  ACTION_COMMENTS: ({ carId, type }) => {
    wrapAction(() => wsActions.socket.emit('ACTION_COMMENTS', { carId, type }))
  },
}

/**
 *
 * @param {Socket} socket
 */
function bindWsEvents (socket) {
  wsActions.socket = socket

  Object.keys(wsEvents).forEach(eventName => {
    socket.on(eventName, (args) => CarEventEmitter.emit(eventName, args))
  })
}

/**
 * Get cars.
 * @param {object} params - query params
 * @param {number} params.take - maximum number of elements
 * @param {number} params.skip - number of elements to skip
 * @param {string} params.search - search query
 * @returns
*/
const loadCars = ({ take, skip, search, all }) => {
    const query = concantQuery({ take, skip, search, all })
    return api.get(`/statistical/cars${query}`)
}
const loadMarketplaceVehicles = ({ take, skip, search, all }) => {
  const query = concantQuery({ take, skip, search, all })
  return api.get(`/statistical/vehicle-manager${query}`)
}
const loadDraftCars = ({ take, skip, search, all }) => {
  const query = concantQuery({ take, skip, search, all })
  return api.get(`/statistical/draftcars${query}`)
}

const loadCarBYId = ({ id }) => {
  return api.get(`/statistical/car/by-id/${id}`)
}

const getSiteConfigByModule = () => {
  return api.get(`/site-config`)
}
  
export {
    loadCars,
    wsListeners,
    bindWsEvents,
    wsActions,
    wsEvents,
    loadCarBYId,
    loadDraftCars,
    loadMarketplaceVehicles,
    getSiteConfigByModule
}